/**
 *
 * @param {*} text Markdown text in form [text](url)
 * @returns HTML element containing text with link
 */
export function convertLink(text) {
  //check for links [text](url)
  let elements = text.match(/\[.*?\]\(.*?\)/g);
  if (elements != null && elements.length > 0) {
    let index = 0;
    for (let el of elements) {
      let txt = el.match(/\[(.*?)\]\((.*?)\)/)[1]; //get only the txt
      let url = el.match(/\[(.*?)\]\((.*?)\)/)[2]; //get only the link

      text = text.replace(
        el,
        '<a href="' +
          url +
          '" @click.stop target="_blank" rel="noopener noreferrer" class="text-link--lib">' +
          txt +
          "</a>"
      );
      index = index + 1;
    }
  }
  text = "<span>" + text + "</span>";
  return {
    template: text,
  };
}

/**
 * Decides whether timeslots for the input timezone should
 * be formatted in AM/PM format or not.
 * @param {*} timezone timezone string
 * @returns boolean
 */
export function isAM_PM(timezone) {
  if (timezone.startsWith("America") || timezone.startsWith("Australia")) {
    return true;
  }
  return false;
}

/**
 * @description https://docs.stripe.com/currencies#zero-decimal
 * Last updated: 23-10-2024
 */
export const CURRENCY_WITHOUT_DECIMALS = [
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "JPY",
  "KMF",
  "KRW",
  "MGA",
  "PYG",
  "RWF",
  "UGX",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF",
];

/**
 * Calculates the amount required to be passed to stripe for checkout.
 * For zero-decimal currencies, the amount has to be provided as is, and
 * for currencies with decimals the price has to be multiplied by 100,
 * as cents, pennies etc. should also be bookable.
 * @param {string} currency
 * @param {number} price
 * @returns
 */
export function getStripeAmount(currency, price) {
  if (CURRENCY_WITHOUT_DECIMALS.includes(currency.toUpperCase())) {
    return price;
  }
  return Math.ceil(price * 100);
}
